import { useContext } from "react";
import { PermissionsContext } from "@/app/_providers/PermissionsProvider/PermissionsProvider";

export const usePermissionsContext = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error(
      "usePermissionsContext must be used within a PermissionsProvider"
    );
  }
  return context.permissions;
};
